import script from "./FlowbiteEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowbiteEditor.vue?vue&type=script&setup=true&lang=js"

import "./FlowbiteEditor.vue?vue&type=style&index=0&id=05601f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05601f88"]])

export default __exports__